module.exports = __webpack_public_path__ + "img/twitter-icon.694426a7867616de6f0fcf6db62ece17.svg";